import { colors } from "@/theme/colors";
import { IllustrationSvg } from "./IllustrationSvg";
import { Backdrop } from "./shapes";

/**
 * Flat illustration for Care & support: a shield with a check — your product
 * looked after and kept current after launch.
 */
export function CareIllustration() {
  return (
    <IllustrationSvg>
      {/* Soft backdrop */}
      <Backdrop x={44} y={22} width={132} height={94} fill={colors.paper} />
      {/* Shield */}
      <path
        d="M110 24 L142 36 V68 C142 88 128 100 110 108 C92 100 78 88 78 68 V36 Z"
        fill={colors.primary}
      />
      {/* Checkmark */}
      <path
        d="M98 66 l9 9 l18 -19"
        fill="none"
        stroke={colors.paper}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IllustrationSvg>
  );
}
